import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "navigation-gamification-dice",
  "use": "navigation-gamification-dice-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"navigation-gamification-dice\"><path d=\"M8.727 7.364a1.364 1.364 0 11-2.727 0 1.364 1.364 0 012.727 0zm7.273 0a1.364 1.364 0 11-2.727 0 1.364 1.364 0 012.727 0zm0 7.272a1.364 1.364 0 11-2.727 0 1.364 1.364 0 012.727 0zm-7.273 0a1.364 1.364 0 11-2.727 0 1.364 1.364 0 012.727 0zM12.364 11a1.363 1.363 0 11-2.727 0 1.363 1.363 0 012.727 0z\" fill=\"currentColor\" /><rect x=\"1\" y=\"1\" width=\"20\" height=\"20\" rx=\"4\" stroke=\"currentColor\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/navigation-gamification-dice.svg
// module id = gREG
// module chunks = 39 44